/**
 * useSubscription hook.
 *
 * Returns the current user's Stripe subscription status, read from
 * currentUser.attributes.profile.privateData.stripeSubscription.
 *
 * The subscription metadata is written to privateData by the admin or a
 * webhook handler after successful subscription creation.
 *
 * Usage:
 *   const { hasSubscription, status, isCanceled, isPastDue } = useSubscription();
 */
import { useSelector } from 'react-redux';

const useSubscription = () => {
  const currentUser = useSelector(state => state.user?.currentUser);
  const sub = currentUser?.attributes?.profile?.privateData?.stripeSubscription || null;

  return {
    subscription: sub,
    hasSubscription: !!sub && sub.status === 'active',
    status: sub?.status || null,
    isCanceled: sub?.status === 'canceled',
    isPastDue: sub?.status === 'past_due',
    isTrialing: sub?.status === 'trialing',
    subscriptionId: sub?.id || null,
    customerId: sub?.customer || null,
  };
};

export default useSubscription;
